import React from 'react';
import DailyComplianceTasks from './DailyComplianceTasks';

const Tasks = () => {
  return <DailyComplianceTasks mode="tasks" />;
};

export default Tasks;
